/**
 * Maps a user's pilot country (ISO 2-letter code from JWT) to their
 * default UI language for the i18n toggle.
 *
 * Country managers see their language by default on first login;
 * admins always see English; viewers default to English with a
 * dropdown to choose any.
 */

export const PILOT_LANGUAGES = ['en', 'it', 'fr', 'de', 'cs', 'el']

export const COUNTRY_TO_LANGUAGE = {
  IT: 'it',
  FR: 'fr',
  DE: 'de',
  CZ: 'cs',
  GR: 'el',
}

export const LANGUAGE_LABELS = {
  en: 'English',
  it: 'Italiano',
  fr: 'Français',
  de: 'Deutsch',
  cs: 'Čeština',
  el: 'Ελληνικά',
}

export const LANGUAGE_SHORT = {
  en: 'EN',
  it: 'IT',
  fr: 'FR',
  de: 'DE',
  cs: 'CS',
  el: 'EL',
}

/**
 * Resolves the default language for a user based on their role and country.
 * - admin → always 'en'
 * - country_manager → their country's pilot language (or 'en' as fallback)
 * - viewer → 'en' (they can change via the dropdown)
 */
export function defaultLanguageForUser(user) {
  if (!user) return 'en'
  if (user.role === 'admin') return 'en'
  if (user.role === 'country_manager') {
    return COUNTRY_TO_LANGUAGE[user.country_code] || 'en'
  }
  return 'en'
}
